module.exports = __webpack_public_path__ + "static/img/5.550edb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/5.png
// module id = s6Ke
// module chunks = 0